/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-else-return */

import { Link } from 'react-router-dom';
import {
  BsFillBellFill,
  BsFillExclamationCircleFill,
  BsFillFileEarmarkFill,
  BsFillPeopleFill
} from 'react-icons/bs';

import { statusEnum } from '../../../utils/dataStatus';
import PillStatus from '../../../components/PillStatus/PillStatus';
import { formatDate, formatMonthYear } from '../../../utils/formatUtils';
import './columns.scss';
import RequestsIcon from '../../../components/RequestsIcon/RequestsIcon';
import ComponentWithTooltip from '../../../components/ComponentWithTooltip/ComponentWithTooltip';

export const CellShowStatus = ({ value, row }) => {
  const totally = row.original?.proveedoresTotales || 0;
  const accepted = row.original?.proveedoresAceptados || 0;
  const reject = row.original?.proveedoresRechazados || 0;
  const pastTime = row.original?.pasoFechaRespuesta || false;

  const responsetotally = accepted + reject === totally;

  return (
    <PillStatus
      accepted={accepted}
      idStatus={value}
      pastTime={pastTime}
      reject={reject}
      responsetotally={responsetotally}
      totally={totally}
    />
  );
};
export const toUrl = ({ solicitudMensualizada, estadoEnum, id }) => {
  if (solicitudMensualizada === true) {
    return `/detailmonthly/${id}`;
  } else if (estadoEnum === statusEnum.borrador) {
    return `/edit/${id}`;
  } else {
    return `/detail/${id}`;
  }
};
const linkSDS = ({ value, cell }) => {
  const hasMessage = cell.row.original.nuevoMensaje;
  const inactivityAlert = cell.row?.original?.alertaInactividad;
  const newAttachedDoc = cell.row?.original?.nuevosAdjuntos;
  const multipleRoles = cell.row?.original?.multiplesRoles;

  // This was a Link component, and was changed because the redirect must be in the row instead only this cell
  return (
    <div className="d-flex justify-content-between align-items-center">
      <Link
        style={{
          textDecoration: 'none',
          color: '#0063bd'
        }}
        to={toUrl(cell.row.original)}
      >
        {value}
      </Link>
      <div className="d-flex align-items-end">
        {hasMessage && <BsFillBellFill className="icon-bell" />}
        {inactivityAlert && (
          <ComponentWithTooltip tooltipText="Alerta: 45 días de antigüedad">
            <BsFillExclamationCircleFill className="icon-bell" />
          </ComponentWithTooltip>
        )}
        {newAttachedDoc && (
          <ComponentWithTooltip tooltipText="Nueva documentación adjunta">
            <BsFillFileEarmarkFill className="icon-bell" />
          </ComponentWithTooltip>
        )}
        {multipleRoles && (
          <ComponentWithTooltip tooltipText={`${cell.row?.original?.multiplesRolesDescripcion}`}>
            <BsFillPeopleFill className="icon-bell" />
          </ComponentWithTooltip>
        )}
      </div>
    </div>
  );
};

const cellShowRequestsIcon = ({ row }) => (
  <RequestsIcon
    color={row.original?.iconoSolicitudServicio?.color}
    letter={row.original?.iconoSolicitudServicio?.letra || row.original?.numero[0]}
    shape={row.original?.iconoSolicitudServicio?.forma}
  />
);

const priorityCell = ({ row }) => {
  const prioridad = row?.original?.prioridad;

  if (!prioridad.id) {
    return <>{prioridad.nombre}</>;
  }

  return <ComponentWithTooltip tooltipText={prioridad.nombre}>{prioridad.id}</ComponentWithTooltip>;
};

const cellShowUbicationAndContract = ({ row }) => {
  const numeroContrato = row?.original?.numeroContrato;
  const solicitudMensualizada = row?.original?.solicitudMensualizada;
  const contrato = row?.original?.ubicacionContrato;
  const unidadesNegocioText = row?.original?.unidadesNegocio?.join(', ');
  const text = contrato && numeroContrato ? `${contrato} - ${numeroContrato}` : `${contrato}`;
  const tooltipText = solicitudMensualizada ? unidadesNegocioText : text;

  return (
    <ComponentWithTooltip tooltipText={tooltipText}>
      <p className="text-truncate">{contrato}</p>
    </ComponentWithTooltip>
  );
};

const cellShowTypeIO = (handleClick) => {
  const CellComponent = ({ row }) => {
    const typeIO = row?.original?.tiposImputacion;

    const displayText =
      typeIO && typeIO.length > 0 ? `${typeIO.length > 1 ? ` +${typeIO.length - 1}` : ''}` : '';

    return (
      <div>
        {typeIO[0] === '--' ? (
          <span>{typeIO[0]}</span>
        ) : (
          <button
            onClick={() => handleClick(row?.original)}
            style={{
              textDecoration: 'none',
              color: '#0063bd',
              background: 'none'
            }}
            type="button"
          >
            {typeIO[0]} {displayText}
          </button>
        )}
      </div>
    );
  };

  CellComponent.displayName = 'CellComponent';

  return CellComponent;
};

const symbol = {
  Header: 'S',
  accesor: 'simbolo',
  Cell: cellShowRequestsIcon,
  hideSort: true
};
const number = {
  Header: 'N°',
  accessor: 'numero',
  Cell: linkSDS
};
const typeIO = (handle) => ({
  Header: 'Tipo OI',
  accessor: 'tiposImputacion',
  Cell: cellShowTypeIO(handle)
});
const service = {
  Header: 'Servicio',
  accessor: 'servicio',
  style: {
    maxWidth: '250px'
  }
};
const priority = {
  Header: 'Pr.',
  accessor: 'prioridad',
  Cell: priorityCell,
  style: {
    width: '30px'
  }
};
const ubication = {
  Header: 'Ubicación / Contrato',
  accessor: 'ubicacionContrato',
  Cell: cellShowUbicationAndContract,
  style: {
    maxWidth: '250px'
  }
};
const answerDate = {
  Header: 'Fecha de respuesta',
  accessor: 'fecha',
  Cell: formatDate,
  style: {
    width: '150px'
  }
};

const state = {
  Header: 'Estado',
  accessor: 'estadoEnum',
  Cell: CellShowStatus,
  style: {
    width: '120px'
  }
};
const doDate = {
  Header: 'Fecha prob. realización',
  accessor: 'fecha',
  Cell: ({ row }) => {
    // eslint-disable-next-line
     // TO-DO 24-06 funcion
    if (row.original.solicitudMensualizada) {
      return formatMonthYear(row.original.fecha).toUpperCase();
    } else {
      return formatDate({
        value: row.original.fecha
      });
    }
  },
  style: {
    width: '150px'
  }
};

export const columns = (handleClickTypeIO) => [
  symbol,
  number,
  typeIO(handleClickTypeIO),
  service,
  priority,
  ubication,
  answerDate,
  state
];

export const columnsAlternative = (handleClickTypeIO) => [
  symbol,
  number,
  typeIO(handleClickTypeIO),
  service,
  priority,
  ubication,
  doDate,
  state
];
